
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { dataModule } from '@/store/data';
import NSelect from '@/uikit/select/NSelect.vue';

@Options({
  name: 'CameraName',
  components: { NSelect }
})
export default class DataSourceName extends Vue {
  @Prop({ type: Number, required: true })
  readonly modelValue!: number;

  @Prop({ type: Boolean, default: false })
  readonly accent?: boolean;

  @Prop({ type: String, default: 'camera' })
  readonly sourceType?: string;

  private item: any = null;

  get name() {
    return this.item?.name ?? '...';
  }

  created() {
    this.load();
  }

  @Watch('modelValue')
  async load() {
    const module = this.sourceType === 'camera' ? dataModule.camerasModule : dataModule.videosModule;
    this.item = null;
    this.item = await module.getById(this.modelValue);
  }
}
